export const DEG_PER_RAD = 180 / Math.PI;
export const INTERVAL_TIME = 50;
export const MAX_HISTORY_LENGTH = 100;
